<template>
<div>
    <Row type="flex" justify="end" style="margin-bottom: 40px;">
        <i-col>
            <i-select v-model="modulo" clearable placeholder="Modulo" class="w-64 ml-2">
                <Option v-for="item in modulos" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <i-select v-model="funcao" v-if="modulo!=null" clearable placeholder="Função" class="w-64 ml-2">
                <Option v-for="item in funcoes" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <i-select v-model="funcionalidade" v-if="funcao!=null && modulo!=null" clearable placeholder="Funcionalidade" class="w-64 ml-2">
                <Option v-for="item in funcionalidades" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <i-select filterable v-model="analista" clearable placeholder="Analista" style="width:200px;margin-left:7px;">
                <Option v-for="item in analistas" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <i-select filterable v-model="tipo" clearable placeholder="Tipo de ticket" style="width:200px;margin-left:7px;">
                <Option v-for="item in tipos" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <InputNumber @input="carregarDados(false)" :active-change="false" :min="1" v-model="periodo" style="margin-left:7px;"></InputNumber>
            <i-switch @on-change="carregarDados(false)" false-value="mensal" size="large" style="margin: 7px 0 7px 7px;"
                        true-value="semanal" v-model="formato">
                <span slot="open">SEM</span>
                <span slot="close">MEN</span>
            </i-switch>
        </i-col>
    </Row>
    <bar-chart
        v-if="mostrar_grafico"
        :options="dados_grafico"
        @click="carregarTabela"
    />
    <Spin size="large" fix v-if="carregar"></Spin>
    <tickets-table :csv="csv" :analistas="analistas" :loading="carregar_tabela"
                  :tickets="tickets" 
                  ocultarRelatores ocultarCadastros 
                  ocultarObservacao ocultarFinalizados 
                  exibirCriticidade exibirDetalhes
                  exibirTempoDev exibirModulo exibir-incidentes
                  v-if="mostrar_tabela"></tickets-table> 
</div>
</template>

<script>
    const {moment} = require("../../../helpers/utils.js")
    import accounting from "accounting"
    import _ from 'lodash'
    export default {
        components: {
            BarChart: () => import("../../../components/charts/BarChart.vue"),
        },
        props: {
            download: Boolean,
            refresh: Boolean,
            close: Boolean
        },
        data:()=>({
            modulo:null,
            modulos:[],
            funcao:null,
            funcoes:[],
            funcionalidade:null,
            funcionalidades:[],
            analista: null,
            tipo: null,
            periodo: 6,
            formato: 'semanal',
            tipos: [
                    {
                        label: "Bug",
                        value: 32
                    },
                    {
                        label: "Melhoria",
                        value: 33
                    },
                    {
                        label: "SS",
                        value: 35
                    },
                    {
                        label: "MVP",
                        value: 45
                    }
            ],
            dados: [],
            dados_grafico: {},
            bug:[],
            mel:[],
            ss:[],
            mvp:[],
            mostrar_grafico:true,
            carregar: false,
            mostrar_tabela: false,
            carregar_tabela: false,
            tickets:[],
            csv:false,
            legenda:null,
        }),
        computed: {
            analistas() {
                let analistas = this.$store.getters['analistas']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }))
                return _.orderBy(analistas, ['label'],['asc'])
            },
        },
        methods: {

            async carregarDados(filtros) {
                this.carregar = true
                const URI = `ticket/estatisticas/ranque`
                if (filtros) {
                    const {data} = await this.$axios.get(URI,{params: {formato:this.formato, periodo:this.periodo,filtros:filtros}})
                    this.dados = data.reverse().map(item =>{
                        return item.map(value => {
                            value["tempo_dev"] = 0
                            if(value.timeline){
                                value.timeline.map(timeline =>{
                                    value["tempo_dev"] = parseFloat(timeline.tempo_dev)
                                })
                            }
                            return value
                        })
                    })
                    this.legenda = this.caregarLegenda(data.length)
                    this.filtrarDados()
                    this.carregar = false
                } else {
                    const {data} = await this.$axios.get(URI,{params: {formato:this.formato,periodo:this.periodo}})
                    
                    this.dados = data.reverse().map(item =>{
                        return item.map(value => {
                            value["tempo_dev"] = 0
                            if(value.timeline){
                                value.timeline.map(timeline =>{
                                    value["tempo_dev"] = parseFloat(timeline.tempo_dev)
                                })
                            }
                            return value
                        })
                    })
                    this.legenda = this.caregarLegenda(data.length)
                    this.modulo = null
                    this.funcao = null
                    this.funcionalidade = null
                    this.filtrarDados()
                    this.carregar = false
                }
            },

            filtrarDados() {
                let dados = this.filtros()
                this.mostrarDados([
                    dados.map((item) => this.filtrarPrazo(item,32)),
                    dados.map((item) => this.filtrarPrazo(item,33)),
                    dados.map((item) => this.filtrarPrazo(item,35)),
                    dados.map((item) => this.filtrarPrazo(item,45)),
                ])
            },

            filtros(){
                const analista = this.analista
                const tipo = this.tipo
                let dados = this.dados.map((item)=>item.filter(item => {
                        if (analista && tipo) {
                            return analista == item.id_pessoa && tipo == item.tipo_id
                        }
                        if (analista) {
                            return analista == item.id_pessoa
                        }
                        if (tipo) {
                            return tipo == item.tipo_id
                        }
                        return item
                }))
                return dados
            },

            filtrarPrazo(dados,type) {
                dados = dados.filter(item => {
                    if (item.tipo_id == type) {
                        return item
                    }
                }) 
                return dados
            },

            carregarTabela(params) {
                if (params.selected==false){
                    this.mostrar_tabela = true
                    this.carregar_tabela = true
                    if (params.seriesType === "line") {
                        this.tickets = this.dados[params.dataIndex]
                    } else {
                        if(params.seriesIndex==0){
                            this.tickets = this.bug[params.dataIndex]     
                        } else {
                            if(params.seriesIndex==1){
                                this.tickets = this.mel[params.dataIndex]           
                            } else {
                                if(params.seriesIndex==2){
                                    this.tickets = this.ss[params.dataIndex]      
                                } else {
                                    if(params.seriesIndex==3){
                                        this.tickets = this.mvp[params.dataIndex]      
                                    }
                                }
                            }
                        }      
                    }
                    this.carregar_tabela = false
                } else {
                    this.mostrar_tabela = false;
                }
            },

            mostrarDados([
                bug,
                mel,
                ss,
                mvp
            ]) {
                bug = bug.map(item=>
                    item.map(function(value) {
                        value['checkout'] = accounting.toFixed((value.prazo - value.tempo_dev),2)*1
                        return value
                    })
                )
                this.bug = bug
                let tempo_bug = bug.map((item)=> ({
                    tempo_dev: item.reduce( ( prevVal, elem ) => prevVal + elem.tempo_dev, 0 ),
                    checkout: item.reduce( ( prevVal, elem ) => prevVal + elem.checkout, 0 ),
                    prazo: item.reduce( ( prevVal, elem ) => prevVal + elem.prazo, 0 ),
                }))
                mel = mel.map(item=>
                    item.map(function(value) {
                        value['checkout'] = accounting.toFixed((value.prazo - value.tempo_dev),2)*1
                        return value
                    })
                )
                this.mel = mel
                let tempo_mel = mel.map((item)=> ({
                    tempo_dev: item.reduce( ( prevVal, elem ) => prevVal + elem.tempo_dev, 0 ),
                    checkout: item.reduce( ( prevVal, elem ) => prevVal + elem.checkout, 0 ),
                    prazo: item.reduce( ( prevVal, elem ) => prevVal + elem.prazo, 0 ),
                }))
                ss = ss.map(item=>
                    item.map(function(value) {
                        value['checkout'] = accounting.toFixed((value.prazo - value.tempo_dev),2)*1
                        return value
                    })
                )
                this.ss = ss
                let tempo_ss = ss.map((item)=> ({
                    tempo_dev: item.reduce( ( prevVal, elem ) => prevVal + elem.tempo_dev, 0 ),
                    checkout: item.reduce( ( prevVal, elem ) => prevVal + elem.checkout, 0 ),
                    prazo: item.reduce( ( prevVal, elem ) => prevVal + elem.prazo, 0 ),
                }))
                mvp = mvp.map(item=>
                    item.map(function(value) {
                        value['checkout'] = accounting.toFixed((value.prazo - value.tempo_dev),2)*1
                        return value
                    })
                )
                this.mvp = mvp
                let tempo_mvp = mvp.map((item)=> ({
                    tempo_dev: item.reduce( ( prevVal, elem ) => prevVal + elem.tempo_dev, 0 ),
                    checkout: item.reduce( ( prevVal, elem ) => prevVal + elem.checkout, 0 ),
                    prazo: item.reduce( ( prevVal, elem ) => prevVal + elem.prazo, 0 ),
                }))

                const totais = this.filtros().map((value) => ({
                    value: value.length || 0,
                    itemStyle: {
                        barBorderColor: '#FF1744',
                    }
                }))
                this.dados_grafico = {
                    tooltip: {
                        type:'shadow',
                        formatter:(params)=>{
                            if (params.seriesType === "line") {
                                return `
                                        <span>${params.seriesName}</span><br>
                                        <span>${params.marker} Tickets: ${params.data.value}</span><br>
                                        <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FFAB5A;"></span><span> Tempo: ${accounting.toFixed(tempo_bug[params.dataIndex].tempo_dev+tempo_mel[params.dataIndex].tempo_dev+tempo_ss[params.dataIndex].tempo_dev+tempo_mvp[params.dataIndex].tempo_dev,2)} hs</span>
                                    `
                            } else {
                                if(params.seriesIndex==0){
                                    return `
                                        <span>${params.seriesName}</span><br>
                                        <span>${params.marker} Tickets: ${params.data.value}</span><br>
                                        <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FFAB5A;"></span><span> Tempo: ${accounting.toFixed(tempo_bug[params.dataIndex].tempo_dev,2)} hs</span>
                                    ` 
                                } else {
                                    if(params.seriesIndex==1){
                                        return `
                                            <span>${params.seriesName}</span><br>
                                            <span>${params.marker} Tickets: ${params.data.value}</span><br>
                                            <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FFAB5A;"></span><span> Tempo: ${accounting.toFixed(tempo_mel[params.dataIndex].tempo_dev,2)} hs</span>
                                        ` 
                                    } else {
                                        if(params.seriesIndex==2){
                                            return `
                                                <span>${params.seriesName}</span><br>
                                                <span>${params.marker} Tickets: ${params.data.value}</span><br>
                                                <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FFAB5A;"></span><span> Tempo: ${accounting.toFixed(tempo_ss[params.dataIndex].tempo_dev,2)} hs</span>
                                            ` 
                                        } else {
                                            if(params.seriesIndex==3){
                                                return `
                                                    <span>${params.seriesName}</span><br>
                                                    <span>${params.marker} Tickets: ${params.data.value}</span><br>
                                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FFAB5A;"></span><span> Tempo: ${accounting.toFixed(tempo_mvp[params.dataIndex].tempo_dev,2)} hs</span>
                                                ` 
                                            }
                                        }
                                    }
                                }
                               
                            }
                        }
                    },
                    legend: {},
                    xAxis: {
                        data: this.legenda,
                        silent: false,
                        axisLine: {onZero: true},
                        splitArea: {show: false},
                        splitLine: {show: false}
                    },
                    yAxis: {},
                    grid: {
                        left: 50,
                        right: 50
                    },
                    label: {
                        position: 'top',
                        show: true,
                        formatter: (param) => param.value || '',
                    },
                    series: [
                        {
                            name: 'Bug',
                            type: 'bar',
                            color: '#FF1744',
                            data: bug.map((value) => ({
                                value: value.length || '',
                                itemStyle: {
                                    barBorderColor: '#FF1744',
                                }
                            }))
                        },
                        {
                            name: 'Melhorias',
                            type: 'bar',
                            color: '#FFDF20',
                            data: mel.map((value) => ({
                                value: value.length || '',
                                itemStyle: {
                                    barBorderColor: '#FFDF20',
                                }
                            }))
                        },
                        {
                            name: 'SS',
                            type: 'bar',
                            color: '#2196F3',
                            data: ss.map((value) => ({
                                value: value.length || '',
                                itemStyle: {
                                    barBorderColor: '#2196F3',
                                }
                            }))
                        },
                        {
                            name: 'MVP',
                            type: 'bar',
                            color: '#3F51B5',
                            data: mvp.map((value) => ({
                                value: value.length || '',
                                itemStyle: {
                                    barBorderColor: '#3F51B5',
                                }
                            }))
                        },
                        {
                            name: 'Totais',
                            type: 'line',
                            color: '#263238',
                            data: totais,
                        }
                    ]
                }
            },

            caregarLegenda(size) {
                let legenda = []
                if (this.formato === "semanal") {
                    legenda = ["Esta sem.", "1 sem. atrás"]
                    for (let i = 2; i < size; i++) {
                        legenda[i] = `${i} sem. atrás`
                    }
                } else {
                    for (let i = 0; i < size; i++) {
                        legenda[i] = moment().subtract(i, 'months').format("MMMM/YY")
                    }
                }
                return legenda.reverse()
            },

            async getModulos(){
                let modulos = await this.getChildren(1)
                this.modulos = _.orderBy(modulos, ['label'],['asc'])
            },

            async getChildren(id) {
                if (!id) return [];
                const {data: children} = await this.$axios.get(`tree/${id}/children`)
                return children.map(item => ({
                    value: item.id,
                    label: item.nome
                }))
            },
        },
        created() {
            this.getModulos()
            this.carregarDados(false)
        },
        watch: {
            refresh(){
                if (this.refresh){
                    this.modulo = null
                    this.funcao = null
                    this.funcionalidade = null
                    this.analista = null
                    this.tipo = null
                    this.formato = 'semanal'
                    this.periodo = 6
                    this.mostrar_tabela = false
                    this.carregarDados(false)
                }
            },
            download(){
                this.csv=this.download
            },
            async modulo(){
                if(this.modulo){
                    let funcoes = await this.getChildren(this.modulo)
                    this.funcoes = _.orderBy(funcoes, ['label'],['asc'])
                    this.carregarDados({modulo:this.modulo})
                    this.mostrar_tabela = false
                } else {
                    this.carregarDados(false)
                    this.mostrar_tabela = false
                }
            },
            async funcao(){
                if (this.funcao){
                    let funcionalidades = await this.getChildren(this.funcao)
                    this.funcionalidades = _.orderBy(funcionalidades, ['label'],['asc'])
                    this.carregarDados({funcao:this.funcao})
                    this.mostrar_tabela = false
                } else {
                    this.carregarDados({modulo:this.modulo})
                    this.mostrar_tabela = false
                }
            },
            async funcionalidade(){
                if (this.funcionalidade) {
                    this.carregarDados({funcionalidade:this.funcionalidade})
                    this.mostrar_tabela = false
                } else {
                    this.carregarDados({funcao:this.funcao})
                    this.mostrar_tabela = false
                }
            },
            analista(){
                this.filtrarDados()
                this.mostrar_tabela = false
            },
            tipo(){
                this.filtrarDados()
                this.mostrar_tabela = false
            },
            close(){
                if (this.close){
                    this.mostrar_tabela = false
                    this.mostrar_grafico = false
                } else {
                    this.mostrar_grafico = true
                }    
            },
            mostrar_tabela(){
                this.$emit('download',this.mostrar_tabela)
            }
        }
}
</script>
